import { render, staticRenderFns } from "./transaction-modify.vue?vue&type=template&id=7f457e0a&"
import script from "./transaction-modify.vue?vue&type=script&lang=js&"
export * from "./transaction-modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports